export const environment = {
  surveyboxProURL: 'https://dev.surveypro.in.th',
  surveyboxURL: 'https://dev.surveypro.in.th',
  // ใช้ path relative '/core' (ไม่ใส่ host) เพื่อให้เป็น same-origin ทั้ง 2 ฝั่ง → cookie เป็น first-party:
  //  - บน K8s: FE serve ที่ dev.surveypro.in.th, /core/api วิ่ง same-origin ไป ingress -> API
  //  - บน localhost dev: proxy.conf.json จับ /core ส่งต่อไป K8s ให้
  apiURL: '/core',
  imgURL: '/core',
  contentURL: '',
  // เติมช่อง login อัตโนมัติเฉพาะ local dev (prod เว้นว่างใน environment.ts)
  defaultEmail: 'somchai@surveybox.local',
  defaultPassword: 'Test@1234',
  // TODO: ใส่ OAuth Client ID จาก Google Cloud Console (Credentials > OAuth client ID > Web application)
  googleClientId: '',
};
